import { render, staticRenderFns } from "./RoutingPlanDetail.vue?vue&type=template&id=2072d298"
import script from "./RoutingPlanDetail.vue?vue&type=script&lang=js"
export * from "./RoutingPlanDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports